$('.has-video').click(function () {
	$('.VideoModal .videosrc').attr('src', '');
	$('.VideoModal .videosrc').attr('src', $(this).data('src'));

	$('.VideoModal').modal('show');
})


$('.VideoModal').on('shown.bs.modal', function () {
	$('.VideoModal .videosrc').attr('src', '');
})







const bootstrapSelect = require('bootstrap-select');

$(`.selectpickerCustom:not(.selectpicker)`).selectpicker();


$(function () {
	$('[data-toggle="tooltip"]').tooltip();
})



//select change dependency

//  Filter select

$("body").delegate(".changeAnotherSelect", "change", function (e) {
	let selectToChange = $('#' + $(this).attr('selectToChange'));
	var parentlocationId = $(this).val();
	if (parentlocationId) {
		if (temp_items.length > 0) {
			var options = '';
			for (var i = 0; i < temp_items.length; i++) {
				if (temp_items[i].parentlocationId == parentlocationId) {
					options += "<option value='" + temp_items[i].id + "'>" + temp_items[i].name + "</option>"
				} else {}
			}
		}


		selectToChange.find('option').remove();
		selectToChange.attr('disabled', false);
		selectToChange.selectpicker('refresh');
		selectToChange.append('"' + options + '"').selectpicker();
		selectToChange.selectpicker('refresh');
	}
});



//for contact icons animation
if ($('.contact-icons').length > 0) {
	setTimeout(() => {
		if ($('.has-contact-icons').length < 1) {
			$('.contact-icons.fixed').addClass('show');
		} else {
			$('.contact-icons').not('.fixed').addClass('show');
		}
	}, 120);

}






//menu






(function () {
	CheckinResponsive()
	$(window).resize(function () {
		CheckinResponsive()
	});
})();
if (window.innerWidth < 992) {
	$('.mainMenu .megamenu').addClass('mob-collapse collapse');
	//$('footer .collapse').addClass('mob-collapse')

}

function CheckinResponsive() {
	if (window.innerWidth > 992) {
		$('.mainMenu .megamenu').removeClass('mob-collapse collapse show').addClass(' dropdown-menu');
	} else {

		$('.mainMenu .megamenu').not('.active').not('.mob-collapse').removeClass('dropdown-menu show').addClass(' collapse');


	}


	///
	if ($('.banner__slider.main').length < 1) {
		let paddingTop = $('.navigation').innerHeight();
		$('body').css('paddingTop', paddingTop);

	}



	if ($('.wth_menu_theme_2').length) {
		$('body').addClass('wth_menu_theme_2').css('paddingTop', 0);
		mainHeader.addClass('menu_theme_2');
		$('footer').css('paddingBottom', 0);

	}
}




$(".accordion-wrapper .item .collapse").on("shown.bs.collapse", function(e) {
    let that = $(this);
    //to stop Scrolling on show add class no-scroll-on-show to body
    if (!$('body').hasClass("no-scroll-on-show")) {

        setTimeout(function() {

            var n = that.closest(".item");
            var head_height = n.find('.accordion-header').innerHeight() + 50;
            if ($('.header').length > 0) {
                head_height = $('.header').innerHeight() + n.find('.accordion-header').innerHeight();
            }
            $("html,body").animate({
                //	scrollTop: n.offset().top - head_height - n.find('.accordion-header').innerHeight()
                scrollTop: n.offset().top - head_height
            }, 300)

        }, 10)
    }
})
